module.exports = __webpack_public_path__ + "static/get-ready-1-edd166dea16fdaf55c2f4a603ec6f36b.png";